import React, { PropTypes } from 'react';

import { NitroHeading, NitroBadge, NitroButton, NitroPanel } from 'nitro-components';

import styled from 'styled-components';

const ContentWrapper = styled.div`
  position: relative;
`;
const SummaryChangeButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

const SummaryPanel = ({ title, step, children, action, actionLabel }) => {
  const badge = step ? <NitroBadge variant="secondary" label={step} size={10} align="left" /> : null;

  return (
    <NitroPanel>
      <ContentWrapper>
        <NitroHeading label={title} variant="secondary" size="2" before={badge} />
        {action &&
          <SummaryChangeButton>
            <NitroButton label={actionLabel} action={action} size="compact" />
          </SummaryChangeButton>}

        {children}
      </ContentWrapper>
    </NitroPanel>
  );
};

SummaryPanel.propTypes = {
  title: PropTypes.string,
  step: PropTypes.string,
  children: PropTypes.node,
  action: PropTypes.func,
  actionLabel: PropTypes.string
};

export default SummaryPanel;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/SummaryPanel.js